/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { Story, Meta } from '@storybook/react/types-6-0'
import { ButtonStorybook, ButtonProps } from './Button'
import Center from '../Center/Center'

export default {
  title: 'Buttons/Buttons',
  component: ButtonStorybook,
  decorators: [story => <Center>{story()}</Center>],

  argTypes: {
    fontWeight: { control: 'text' },
    color: { control: 'text' },
    width: { control: 'text' },
    backgroundColor: { control: 'color' },
    children: { control: 'text' },
    onClick: { action: 'clicked' },
  },
} as Meta

const Template: Story<ButtonProps> = args => <ButtonStorybook {...args} />

export const GreenBtn = Template.bind({})
GreenBtn.args = {
  color: 'green',
  children: 'Continue',
}

export const GreenBtnNarrow = Template.bind({})
GreenBtn.args = {
  color: 'greenNarrow',
  children: 'Continue',
}

export const GreenBtnMoreNarrow = Template.bind({})
GreenBtn.args = {
  color: 'greenMoreNarrow',
  children: 'Continue',
}

export const GreenBtnWide = Template.bind({})
GreenBtnWide.args = {
  color: 'greenWide',
  children: 'Sign Up',
}

export const GreyBtn = Template.bind({})
GreyBtn.args = {
  color: 'grey',
  children: 'Search track',
}

export const GreyBtnDisabled = Template.bind({})
GreyBtnDisabled.args = {
  color: 'greyDisabled',
  children: 'Search track',
}

export const GreyBtnDisabledNarrow = Template.bind({})
GreyBtnDisabled.args = {
  color: 'greyDisabledNarrow',
  children: 'Search track',
}

export const GreyBtnDisabledWide = Template.bind({})
GreyBtnDisabledWide.args = {
  color: 'greyDisabledWide',
  children: 'Sign Up',
}

export const GreyBtnDisabledFull = Template.bind({})
GreyBtnDisabledFull.args = {
  color: 'greyDisabledFull',
  children: 'Sign Up',
}

export const WhiteGreyBtn = Template.bind({})
WhiteGreyBtn.args = {
  color: 'white',
  children: 'Continue',
}

export const WhiteGreyBtnWithPlus = Template.bind({})
WhiteGreyBtnWithPlus.args = {
  color: 'white',
  children: '+ Create new campaign',
}

export const WhiteGreenBtn = Template.bind({})
WhiteGreenBtn.args = {
  color: 'whiteGreen',
  children: 'Add Spotify Track',
}

export const WhiteGreenBtnNarrow = Template.bind({})
WhiteGreenBtn.args = {
  color: 'whiteGreenNarrow',
  children: 'Add Spotify Track',
}

export const WhiteGreenBtnWide = Template.bind({})
WhiteGreenBtnWide.args = {
  color: 'whiteGreenWide',
  children: 'Add Spotify Track',
}

export const WhiteGreenBtnMoreWide = Template.bind({})
WhiteGreenBtnWide.args = {
  color: 'whiteGreenMoreWide',
  children: 'Add Spotify Track',
}

export const WhiteGreyBtnSearching = Template.bind({})
WhiteGreyBtnSearching.args = {
  color: 'whiteGreyDisabled',
  children: 'Searching',
}

export const RedBtn = Template.bind({})
RedBtn.args = {
  color: 'red',
  children: 'awaiting',
}

export const RedBtnDisabled = Template.bind({})
RedBtnDisabled.args = {
  color: 'redDisabled',
  children: 'Blocked',
}
